import { createContext, useContext } from "react";

interface OverlayContainerContextType {
    containerRef: React.RefObject<HTMLElement | null> | null;
    container: HTMLElement | null;
}

export const OverlayContainerContext =
    createContext<OverlayContainerContextType>({
        containerRef: null,
        container: null,
    });

export const useOverlayContainer = () => useContext(OverlayContainerContext);

export const usePortalContainer = (): HTMLElement | undefined => {
    const { container, containerRef } = useOverlayContainer();
    return container ?? containerRef?.current ?? undefined;
};
